import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

const getMetaTags = ({
  title, description, published, updated, category, tags,
}) => {
  const metaTags = [
    { itemprop: 'name', content: title },
    { itemprop: 'description', content: description },
    // { itemprop: 'image', content: seoImageURL(_.sample(seoImages.google)) },
    { name: 'description', content: description },
    { name: 'og:title', content: `${title} | The Meteor Chef` },
    // { name: 'og:image', content: seoImageURL(_.sample(seoImages.openGraph)) },
  ];

  if (published) metaTags.push({ name: 'article:published_time', content: published });
  if (updated) metaTags.push({ name: 'article:modified_time', content: updated });
  if (category) metaTags.push({ name: 'article:section', content: category });
  if (tags) metaTags.push({ name: 'article:tag', content: tags });

  return metaTags;
};

const SEO = ({
  schema, title, description, contentType, published, updated, category, tags,
}) => (
  <Helmet
    htmlAttributes={{
      lang: 'en',
      itemscope: undefined,
      itemtype: `http://schema.org/${schema}`,
    }}
    title={title}
    link={
      [
        // { rel: 'canonical', href: seoURL(path) },
      ]
    }
    meta={getMetaTags({
      title,
      description,
      contentType,
      // url: seoURL(path),
      published,
      updated,
      category,
      tags,
    })}
  />
);

// SEO.propTypes = {
//   schema: PropTypes.string,
//   title: PropTypes.string,
//   description: PropTypes.string,
//   path: PropTypes.string,
//   contentType: PropTypes.string,
//   published: PropTypes.string,
//   updated: PropTypes.string,
//   category: PropTypes.string,
//   tags: PropTypes.array,
//   twitter: PropTypes.string,
// };

export default SEO;



// WEBPACK FOOTER //
// ./src/components/common/SEO/index.js